// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9fb2c7b4","206":"6f1daa5f","694":"92ce8a52","695":"7bbee575","779":"3db3b521","787":"f4d8bbf2","819":"8700f3d6","841":"00f3bdb1","903":"6d0386fa"}[chunkId] + ".chunk.js";
};